import { gql } from "@apollo/client";
import SearchableQuerySelector from "components/shared/SearchableQuerySelector";

const FETCH_CUSTOMERS = gql`
  query FETCH_CUSTOMERS {
    customers {
      id
      name
      odooPartnerId
      system
    }
  }
`;

const sortCustomers = (customers = []) => {
  const isChinese = (str) => /[\u3400-\u9FBF]/.test(str || "");

  return [...customers].sort((a, b) => {
    const aIsChinese = isChinese(a.name);
    const bIsChinese = isChinese(b.name);
    if (aIsChinese && !bIsChinese) return -1;
    if (!aIsChinese && bIsChinese) return 1;
    return a.name.localeCompare(b.name);
  });
};

const InlineCustomerSelector = ({
  query = FETCH_CUSTOMERS,
  valueView,
  optionView = (customer) => <div>{customer.name}</div>,
  onChange,
  disabled,
  autoFocus,
  className = "",
}) => {
  return (
    <SearchableQuerySelector
      className={className}
      query={query}
      queryVariables={{}}
      buildQueryVariables={() => ({})}
      resolveOptions={(data, { searchText }) =>
        sortCustomers(data?.customers || []).filter((customer) => {
          if (!searchText) return true;
          const keyword = searchText.toLowerCase();
          return (
            customer.name?.toLowerCase().includes(keyword) ||
            customer.system?.toLowerCase().includes(keyword)
          );
        })
      }
      optionView={optionView}
      valueView={valueView}
      onSelect={onChange}
      disabled={disabled}
      placeholder="Select a customer"
      loadingText="Loading customers..."
      emptyText="No customer found"
      fetchPolicy="network-only"
      autoFocus={autoFocus}
    />
  );
};

export default InlineCustomerSelector;
